module.exports = __webpack_public_path__ + "img/currency-yen.684e914e.svg";